<template>
  <div>
    <v-list-tile class="template" >
      <v-list-tile-content>
        <v-list-tile-title>
          <b>
            <span class="caption">{{ orderItem.qty }} x </span> {{ orderItem.name }}
          </b>
        </v-list-tile-title>
      </v-list-tile-content>

      <v-list-tile-content>
        <v-list-tile-title>
          <b class="caption">
            {{ orderItem.specialRequest }}
          </b>
        </v-list-tile-title>
      </v-list-tile-content>

      <v-list-tile-action>
        {{ orderItem.subTotal | currency}}
      </v-list-tile-action>
    </v-list-tile>

    <v-list>
      <template v-for="attribute in orderItem.itemAttributeList">
        <v-list-tile class="subListing indentation" :key="attribute.uuid" style="padding-left: 20px">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ attribute.name }}
              <!-- <span v-if="!!attribute.subTotal" class="caption grey--text">({{ attribute.subTotal | currency }})</span> -->
            </v-list-tile-title>

            <ul v-if="attribute.attrValueList && attribute.attrValueList.length">
              <li v-for="sub in attribute.attrValueList" :key="sub.code">
                <span class="caption">{{ sub.qty }} x </span>
                {{ sub.name }}

                <span v-if="!!sub.price" class="caption grey--text">
                  ({{ sub.price | currency }})
                </span>
              </li>
            </ul>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </div>
</template>

<script>
export default {
  props: [ 'orderItem' ]
}
</script>

<style>
  .OrderHistoryDetail .v-list--dense .template {
    /* height: 15px !important; */
  }
  .OrderHistoryDetail .v-list--dense .template:not(:first-child) {
    margin: 20px 0px 0px 0px;
  }

  .OrderHistoryDetail .v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
    height: auto !important;
  }

  .OrderHistoryDetail .subListing {
    margin: 5px 0px 0px 0px;
    padding: 0px !important;
  }

  .OrderHistoryDetail .v-list {
    padding: 0px !important;
  }
</style>
<style scoped>
.v-list__tile__sub-title, .v-list__tile__title {
  white-space: normal !important;
  display: contents !important;
}
.v-list-tile-content {
  flex: 1;
  min-width: 0;
  overflow: visible !important;
}

.v-list-tile-title {
  white-space: normal !important;
  height: auto !important;
  line-height: 1.4 !important;
  overflow: visible !important;
}

b {
  display: block; /* Changed from flex to block */
  word-break: break-word;
}

.caption {
  display: inline-block;
  margin-right: 4px;
}

  .indentation {
    margin-left: 25px;
    margin-right: 35px;
  }

  * {
    font-size: var(--text-size-1);
  }
</style>
